// extracted by mini-css-extract-plugin
export default {"confirmation":"confirmation_confirmation__CRXTh","text":"confirmation_text__Ul-Ua"};